var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"tools-card",class:hover ? 'tools-card-show' : 'tools-card-hide',attrs:{"color":"#2E5D90","height":170,"width":70}},[_c('general-tools-list',{attrs:{"hover":hover}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }